import { Modal as MantineModal } from "@mantine/core"
import { Banner, Button, Checkbox, Modal, TextField } from "@shopify/polaris"
import React, { useContext, useEffect, useState } from "react"
import {
	useAddDelegation,
	useDeleteDelegation,
	useGetDelegations,
} from "../../hooks/useFirestoreUserHooks.js"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { useTranslation } from "react-i18next"

export const Delegations = () => {
	const { state, dispatch } = useContext(GlobalStateContext)
	const { t } = useTranslation()

	const getDelegations = useGetDelegations()
	const addDelegation = useAddDelegation()

	const [loadingDelegations, setLoadingDelegations] = useState(true)
	const [delegations, setDelegations] = useState({})

	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [staffAccountEmail, setStaffAccountEmail] = useState("")
	const [checkedStores, setCheckedStores] = useState([])
	const [addDelegationLoading, setAddDelegationLoading] = useState(false)
	const [addDelegationError, setAddDelegationError] = useState(null)

	const fetchDelegations = async () => {
		const delegations = await getDelegations(state.userId)
		setLoadingDelegations(false)
		setDelegations(delegations)
	}

	const addNewDelegation = async () => {
		if (staffAccountEmail === state.userEmail) {
			setAddDelegationError(
				t("account.cannot_add_your_own_account_as_a_staff"),
			)
			return
		}

		setAddDelegationError(null)
		setAddDelegationLoading(true)
		const { success, errorCode } = await addDelegation(
			state.userId,
			staffAccountEmail,
			checkedStores,
		)
		setAddDelegationLoading(false)

		if (success) {
			await fetchDelegations()
			closeModal()
		} else {
			if (errorCode === "no_user_found_with_email") {
				setAddDelegationError(
					t(
						"account.no_user_found_with_that_email_make_sure_the_user_has_logged_into_kopy_at_least_once",
					),
				)
			} else {
				setAddDelegationError(
					t(
						"account.unknown_error_ocurred_when_adding_staff_account",
					),
				)
			}
		}
	}

	const closeModal = () => {
		setStaffAccountEmail("")
		setCheckedStores([])
		setModalIsOpen(false)
	}

	useEffect(() => {
		fetchDelegations()
	}, [])

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: "1rem",
				padding: "1rem 1rem 1rem 1rem",
			}}
		>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					gap: "2rem",
				}}
			>
				<h1
					style={{
						fontSize: "1.3rem",
						lineHeight: "1rem",
						fontWeight: "600",
					}}
				>
					{t("account.staff_accounts")}
				</h1>
				<Button
					size="slim"
					onClick={() => setModalIsOpen((prev) => !prev)}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.3rem",
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1rem"
							height="1rem"
							viewBox="0 0 24 24"
						>
							<path
								fill="currentColor"
								d="M19 14q-.425 0-.713-.288T18 13v-2h-2q-.425 0-.713-.288T15 10q0-.425.288-.713T16 9h2V7q0-.425.288-.713T19 6q.425 0 .713.288T20 7v2h2q.425 0 .713.288T23 10q0 .425-.288.713T22 11h-2v2q0 .425-.288.713T19 14ZM9 12q-1.65 0-2.825-1.175T5 8q0-1.65 1.175-2.825T9 4q1.65 0 2.825 1.175T13 8q0 1.65-1.175 2.825T9 12Zm-7 8q-.425 0-.713-.288T1 19v-1.8q0-.85.438-1.563T2.6 14.55q1.55-.775 3.15-1.163T9 13q1.65 0 3.25.388t3.15 1.162q.725.375 1.163 1.088T17 17.2V19q0 .425-.288.713T16 20H2Z"
							></path>
						</svg>
						<span
							style={{
								color: "#333",
								fontSize: "0.8rem",
								fontWeight: "500",
							}}
						>
							{t("account.add_staff")}
						</span>
					</div>
				</Button>
			</div>
			<p style={{ fontSize: "0.777rem", lineHeight: "0.9rem" }}>
				{t("account.add_staff_accounts_to_your_team_here")}
			</p>

			{loadingDelegations ? (
				<div
					style={{
						height: "5rem",
						width: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						border: "1px dashed #777",
						background: "#efefef",
						borderRadius: "0.5rem",
						gap: "0.5rem",
					}}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="1rem"
						height="1rem"
						viewBox="0 0 24 24"
					>
						<g>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								opacity=".14"
							></rect>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								opacity=".29"
								transform="rotate(30 12 12)"
							></rect>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								opacity=".43"
								transform="rotate(60 12 12)"
							></rect>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								opacity=".57"
								transform="rotate(90 12 12)"
							></rect>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								opacity=".71"
								transform="rotate(120 12 12)"
							></rect>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								opacity=".86"
								transform="rotate(150 12 12)"
							></rect>
							<rect
								width="2"
								height="5"
								x="11"
								y="1"
								fill="currentColor"
								transform="rotate(180 12 12)"
							></rect>
							<animateTransform
								attributeName="transform"
								calcMode="discrete"
								dur="0.75s"
								repeatCount="indefinite"
								type="rotate"
								values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
							></animateTransform>
						</g>
					</svg>
					<span style={{ fontSize: "0.8rem" }}> </span>
				</div>
			) : Object.keys(delegations).length === 0 ? (
				<div
					style={{
						height: "5rem",
						width: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						border: "1px dashed #777",
						background: "#efefef",
						borderRadius: "0.5rem",
					}}
				>
					<span style={{ fontSize: "0.8rem" }}>
						{t("account.no_staff_accounts_found")}
					</span>
				</div>
			) : (
				Object.keys(delegations).map((userId) => {
					const delegation = delegations[userId]

					return (
						<DelegationRow
							key={userId}
							delegation={delegation}
							setDelegations={setDelegations}
						/>
					)
				})
			)}

			<Modal
				small
				title={
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1.5rem"
							height="1.5rem"
							viewBox="0 0 24 24"
						>
							<path
								fill="currentColor"
								d="M19 14q-.425 0-.713-.288T18 13v-2h-2q-.425 0-.713-.288T15 10q0-.425.288-.713T16 9h2V7q0-.425.288-.713T19 6q.425 0 .713.288T20 7v2h2q.425 0 .713.288T23 10q0 .425-.288.713T22 11h-2v2q0 .425-.288.713T19 14ZM9 12q-1.65 0-2.825-1.175T5 8q0-1.65 1.175-2.825T9 4q1.65 0 2.825 1.175T13 8q0 1.65-1.175 2.825T9 12Zm-7 8q-.425 0-.713-.288T1 19v-1.8q0-.85.438-1.563T2.6 14.55q1.55-.775 3.15-1.163T9 13q1.65 0 3.25.388t3.15 1.162q.725.375 1.163 1.088T17 17.2V19q0 .425-.288.713T16 20H2Z"
							></path>
						</svg>
						<span>{t("account.add_staff_account")}</span>
					</div>
				}
				open={modalIsOpen}
				onClose={() => closeModal()}
				primaryAction={{
					content: t("common.add"),
					onAction: () => addNewDelegation(),
					disabled:
						checkedStores.length === 0 ||
						staffAccountEmail.length === 0,
					loading: addDelegationLoading,
				}}
				secondaryActions={[
					{
						content: t("common.cancel"),
						onAction: () => closeModal(),
						disabled: addDelegationLoading,
					},
				]}
			>
				<div
					style={{
						padding: "1rem",
						display: "flex",
						flexDirection: "column",
						gap: "1rem",
					}}
				>
					<Banner>
						{t(
							"account.the_email_entered_must_have_already_logged_into_kopy_at_least_once",
						)}
					</Banner>

					<TextField
						label={t("account.staff_account_email")}
						placeholder="user@gmail.com"
						value={staffAccountEmail}
						onChange={(change) => setStaffAccountEmail(change)}
					></TextField>
					{staffAccountEmail.length === 0 && (
						<p style={{ color: "red" }}>
							{t("account.you_must_enter_an_email")}
						</p>
					)}

					<div>
						<p style={{ fontSize: "0.9rem" }}>
							{t(
								"account.stores_accessible_to_the_staff_account",
							)}
						</p>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								marginBottom: "1rem",
							}}
						>
							{Object.keys(state.stores).map((store) => {
								if (state.staffForStores.includes(store)) {
									return ""
								} else {
									return (
										<Checkbox
											label={store}
											key={store}
											checked={checkedStores.includes(
												store,
											)}
											onChange={(change) =>
												setCheckedStores(
													change
														? [
																...checkedStores,
																store,
															]
														: checkedStores.filter(
																(s) =>
																	s !== store,
															),
												)
											}
										/>
									)
								}
							})}
						</div>

						{checkedStores.length === 0 && (
							<p style={{ color: "red" }}>
								{t(
									"account.you_must_select_at_least_one_store",
								)}
							</p>
						)}
					</div>

					{addDelegationError && (
						<Banner status="critical">{addDelegationError}</Banner>
					)}
				</div>
			</Modal>
		</div>
	)
}

const DelegationRow = (props) => {
	const { delegation, setDelegations } = props
	const { state, dispatch } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const deleteDelegation = useDeleteDelegation()

	const [deletingDelegation, setDeletingDelegation] = useState(false)
	const [confirmDeletionModalOpen, setConfirmDeletionModalOpen] =
		useState(false)

	const _deleteDelegation = async (staffId) => {
		setDeletingDelegation(true)
		await deleteDelegation(state.userId, staffId)
		setDeletingDelegation(false)

		setDelegations((prevDelegations) => {
			const newDelegations = { ...prevDelegations }
			delete newDelegations[staffId]
			return newDelegations
		})
	}

	if (deletingDelegation) {
		document
			.querySelectorAll(".delete-delegation-button")
			.forEach((button) => (button.style.pointerEvents = "none"))
	} else {
		document
			.querySelectorAll(".delete-delegation-button")
			.forEach((button) => (button.style.pointerEvents = "all"))
	}

	return (
		<div
			key={delegation.userEmail}
			style={{
				background: "#e7e7e7",
				padding: "0.5rem 0.777rem",
				borderRadius: "0.5rem",
			}}
		>
			<div
				style={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1.5rem"
					height="1.5rem"
					viewBox="0 0 24 24"
				>
					<path
						fill="#444"
						d="M17 15q-1.05 0-1.775-.725T14.5 12.5q0-1.05.725-1.775T17 10q1.05 0 1.775.725T19.5 12.5q0 1.05-.725 1.775T17 15Zm-5 4v-.4q0-.6.313-1.113t.887-.737q.9-.375 1.863-.563T17 16q.975 0 1.938.188t1.862.562q.575.225.888.738T22 18.6v.4q0 .425-.288.713T21 20h-8q-.425 0-.713-.288T12 19Zm-2-7q-1.65 0-2.825-1.175T6 8q0-1.65 1.175-2.825T10 4q1.65 0 2.825 1.175T14 8q0 1.65-1.175 2.825T10 12Zm0-4ZM2 19v-1.8q0-.85.425-1.563T3.6 14.55q1.5-.75 3.112-1.15T10 13q.875 0 1.75.15t1.75.35l-.85.85l-.85.85q-.45-.125-.9-.163T10 15q-1.45 0-2.838.35t-2.662 1q-.25.125-.375.35T4 17.2v.8h6v.975q0 .325.125.588t.35.437H3q-.425 0-.713-.288T2 19Zm8-1Zm0-8q.825 0 1.413-.588T12 8q0-.825-.588-1.413T10 6q-.825 0-1.413.588T8 8q0 .825.588 1.413T10 10Z"
					></path>
				</svg>
				<div
					style={{
						color: "#444",
						fontSize: "1rem",
						fontWeight: "500",
						flexShrink: "5",
						overflow: "hidden",
						textOverflow: "ellipsis",
					}}
				>
					{delegation.userEmail}
				</div>
				<div
					className="delete-delegation-button"
					onClick={() => setConfirmDeletionModalOpen(true)}
					style={{ cursor: "pointer", marginLeft: "auto" }}
				>
					{deletingDelegation ? (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1rem"
							height="1rem"
							viewBox="0 0 24 24"
						>
							<g>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".14"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".29"
									transform="rotate(30 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".43"
									transform="rotate(60 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".57"
									transform="rotate(90 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".71"
									transform="rotate(120 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".86"
									transform="rotate(150 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									transform="rotate(180 12 12)"
								></rect>
								<animateTransform
									attributeName="transform"
									calcMode="discrete"
									dur="0.75s"
									repeatCount="indefinite"
									type="rotate"
									values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
								></animateTransform>
							</g>
						</svg>
					) : (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1rem"
							height="1rem"
							viewBox="0 0 24 24"
						>
							<path
								fill="red"
								d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
							></path>
						</svg>
					)}
				</div>
			</div>
			<div style={{ display: "flex", flexDirection: "column" }}>
				{delegation.delegatedStores.map((store, i) => {
					return (
						<div key={store} style={{ display: "flex" }}>
							<div style={{ paddingLeft: "0.7rem", width: "8%" }}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="1rem"
									height="1rem"
									viewBox="0 0 14 14"
								>
									<path
										fill="none"
										stroke="#777"
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M13.5 13.5h-12a1 1 0 0 1-1-1V.5"
									></path>
								</svg>
								{i > 0 && (
									<div
										style={{
											width: "1px",
											height: "1.5rem",
											background: "#777",
											marginTop: "-2.5rem",
										}}
									></div>
								)}
							</div>
							<div
								style={{
									paddingLeft: "0.3rem",
									paddingTop: "0.3rem",
									maxWidth: "92%",
									width: "fit-content",
								}}
							>
								<div
									style={{
										background: "#343434",
										borderRadius: "0.3rem",
										padding: "0.4rem 0.5rem",
										color: "#fff",
										display: "flex",
										alignItems: "center",
										gap: "0.3rem",
									}}
								>
									<svg
										style={{ minWidth: "max-content" }}
										xmlns="http://www.w3.org/2000/svg"
										width="0.8rem"
										height="0.8rem"
										viewBox="0 0 24 24"
									>
										<path
											fill="currentColor"
											d="m15.337 23.979l7.216-1.561s-2.604-17.613-2.625-17.73c-.018-.116-.114-.192-.211-.192s-1.929-.136-1.929-.136s-1.275-1.274-1.439-1.411a.384.384 0 0 0-.121-.074l-.914 21.104h.023zM11.71 11.305s-.81-.424-1.774-.424c-1.447 0-1.504.906-1.504 1.141c0 1.232 3.24 1.715 3.24 4.629c0 2.295-1.44 3.76-3.406 3.76c-2.354 0-3.54-1.465-3.54-1.465l.646-2.086s1.245 1.066 2.28 1.066a.944.944 0 0 0 .975-.932c0-1.619-2.654-1.694-2.654-4.359c-.034-2.237 1.571-4.416 4.827-4.416c1.257 0 1.875.361 1.875.361l-.945 2.715l-.02.01zM11.17.83c.136 0 .271.038.405.135c-.984.465-2.064 1.639-2.508 3.992a62.82 62.82 0 0 1-1.889.578C7.697 3.75 8.951.84 11.17.84V.83zm1.235 2.949v.135c-.754.232-1.583.484-2.394.736c.466-1.777 1.333-2.645 2.085-2.971c.193.501.309 1.176.309 2.1zm.539-2.234c.694.074 1.141.867 1.429 1.755c-.349.114-.735.231-1.158.366v-.252c0-.752-.096-1.371-.271-1.871v.002zm2.992 1.289c-.02 0-.06.021-.078.021s-.289.075-.714.21c-.423-1.233-1.176-2.37-2.508-2.37h-.115C12.135.209 11.669 0 11.265 0C8.159 0 6.675 3.877 6.21 5.846c-1.194.365-2.063.636-2.16.674c-.675.213-.694.232-.772.87c-.075.462-1.83 14.063-1.83 14.063L15.009 24l.927-21.166z"
										></path>
									</svg>
									<span
										title={store}
										style={{
											fontSize: "0.777rem",
											lineHeight: "0.8rem",
											overflow: "hidden",
											textOverflow: "ellipsis",
											whiteSpace: "nowrap",
										}}
									>
										{store}
									</span>
								</div>
							</div>
						</div>
					)
				})}
			</div>

			<MantineModal
				opened={confirmDeletionModalOpen}
				onClose={() => setConfirmDeletionModalOpen(false)}
				title={
					<div style={{ fontSize: "1.3rem", fontWeight: "600" }}>
						{t("account.confirm_staff_user_removal")}
					</div>
				}
				centered
				radius="md"
			>
				<div style={{ marginTop: "1rem", marginBottom: "2rem" }}>
					{t("account.do_you_wish_to_remove")}{" "}
					<b>{delegation.userEmail}</b> {t("account.as_staff")}
				</div>

				<p>
					{t(
						"account.after_the_user_is_removed_as_staff_the_kopy_chrome_extension_linking_codes_for_the_following_stores_will_be_reset",
					)}
				</p>

				<ul style={{ marginTop: "1rem", marginBottom: "2rem" }}>
					{delegation.delegatedStores.map((store) => (
						<li key={store}>{store}</li>
					))}
				</ul>

				<Button
					fullWidth
					onClick={() => _deleteDelegation(delegation.userId)}
				>
					{deletingDelegation ? (
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="1rem"
							height="1rem"
							viewBox="0 0 24 24"
						>
							<g>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".14"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".29"
									transform="rotate(30 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".43"
									transform="rotate(60 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".57"
									transform="rotate(90 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".71"
									transform="rotate(120 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									opacity=".86"
									transform="rotate(150 12 12)"
								></rect>
								<rect
									width="2"
									height="5"
									x="11"
									y="1"
									fill="currentColor"
									transform="rotate(180 12 12)"
								></rect>
								<animateTransform
									attributeName="transform"
									calcMode="discrete"
									dur="0.75s"
									repeatCount="indefinite"
									type="rotate"
									values="0 12 12;30 12 12;60 12 12;90 12 12;120 12 12;150 12 12;180 12 12;210 12 12;240 12 12;270 12 12;300 12 12;330 12 12;360 12 12"
								></animateTransform>
							</g>
						</svg>
					) : (
						t("common.confirm")
					)}
				</Button>
			</MantineModal>
		</div>
	)
}
